import React, { useState, useEffect } from "react";

import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import Pagination from "../../components/Pagination";
import ReactFileReader from "react-file-reader";
import { utils, read } from "xlsx";
import { unitConstModel } from "../../constant/ConstantList";

const ProductUpload = () => {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState();
  const [subTypeData, setSubTypeData] = useState();
  const [unitList, setUnitList] = useState([]);

  const { sendRequest: getproductsubitem } = useHttp();

  useEffect(() => {
    getproductsubitem(
      {
        url: "/api/productsubitem/",
      },
      (res) => {
        if (res) {
          //console.log(res);
          setSubTypeData(res);
        }
      }
    );
  }, [getproductsubitem]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          ////console.log("units",res);
          var unit = res.filter(
            (item) =>
              item.unitTypeId == unitConstModel.NumberUnitTypeId ||
              item.unitTypeId == unitConstModel.weightUnitTypeId ||
              item.unitTypeId == unitConstModel.volumnUnitTypeId
          );
          //console.log(unit);
          setUnitList(unit);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData = utils.sheet_to_json(worksheet, { header: 1 });
    setData(parsedData);
    //console.log(parsedData);
    const headers = parsedData[0];

    const jsonData = parsedData.slice(1).map((row, index) => {
      const productSubTypeName = row[headers.indexOf("Product SubType Name")];
      const productSubType =
        subTypeData &&
        subTypeData.find(
          (subType) => subType.productSubTypeName == productSubTypeName
        );

      //console.log(productSubType);

      const productUnitName = row[headers.indexOf("Unit Name")];
      const productUnit =
        unitList &&
        unitList.find((unit) => unit.unitAbbreviation == productUnitName);

      const packsizeUnitName = row[headers.indexOf("Pack Size Unit")];

      const packsizeUnit =
        unitList &&
        unitList.find((unit) => unit.unitAbbreviation == packsizeUnitName);

      const products = {
        productSubTypeId: productSubType ? productSubType.productSubTypeId : "",
        itemId: "ABHDSS0001",
        productName: row[headers.indexOf("Product Name")],
        unitId: productUnit ? productUnit.unitId : "",
        packsize: row[headers.indexOf("Pack Size")] || 0,
        packsizeUnitId: packsizeUnit ? packsizeUnit.unitId : "",
        minimumQty: row[headers.indexOf("Minimum Qty")],
        orgId: localStorage.getItem("orgId"),
        createdBy: parseInt(localStorage.getItem("id")),
        status: 1,
      };

      return products;
    });
    //console.log(jsonData);

    setFormData(jsonData);
  };
  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };

  const { sendRequest: postProducts } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    postProducts(
      {
        url: "/api/productupload/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Products Added successfully`);
        setFormData("");
        setData("");
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <form onSubmit={submitHandler}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row"> </div>
                      <div className="row">
                        <div className="col-9">
                          {" "}
                          <label className="card-title mx-2 my-3 ">
                            Product Details
                          </label>
                        </div>

                        <div className="col-3">
                          <ReactFileReader
                            handleFiles={handleFileUpload}
                            fileTypes={".xlsx"}
                          >
                            <button
                              type="button"
                              className="btn  btn-primary mx-2 my-2"
                            >
                              Upload Excel
                            </button>
                          </ReactFileReader>{" "}
                        </div>
                      </div>
                      <div className="row">
                        <table className="table table-bordered text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {data[0] &&
                                data[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ProductUpload;
